import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "down",
  "use": "down-usage",
  "viewBox": "0 0 9 5",
  "content": "<symbol viewBox=\"0 0 9 5\" id=\"down\"><path fill-rule=\"evenodd\" d=\"M4.5 4.09L0-.001h9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/caret/down.svg
// module id = ./src/assets/icons/caret/down.svg
// module chunks = 1